<h2 mat-dialog-title i18n="@@cookieBanner.header">Wir respektieren Ihre Privatsphäre</h2>
<mat-dialog-content class="mat-typography">
  <p i18n="@@cookieBanner.text">
    Diese Seite nutzt Website Tracking-Technologien von Dritten um ihre Dienste anzubieten und stetig zu verbessern. Ich bin damit
    einverstanden und kann meine Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen oder ändern.
  </p>
  <div>
    <a [routerLink]="'/privacy-notice'" rel="noopener noreferrer" target="_blank" i18n="@@general.privacyPolicy">Datenschutzerklärung</a>
    &nbsp;
    <a [routerLink]="'/imprint'" rel="noopener noreferrer" target="_blank" i18n="@@general.legalNotice">Impressum</a>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close color="primary" cdkFocusInitial (click)="save(true)" i18n="@@general.accept"
    >Akzeptieren</button
  >
  <button mat-stroked-button mat-dialog-close (click)="save(false)" i18n="@@general.decline">Ablehnen</button>
</mat-dialog-actions>
